import * as React from 'react'

import { CheckIcon, LocateFixedIcon, MoveIcon } from 'lucide-react'

import { Button } from '~/client/src/shared/components/Button/Button'
import { Kbd } from '~/client/src/shared/components/shadcn-ui/kbd'
import Localization from '~/client/src/shared/localization/LocalizationManager'

interface IProps {
  onCancel: () => void
  onDone: () => void
  onMoveToMyLocation?: () => void
  isMobileEnv?: boolean
}

const MovePinControls: React.FC<IProps> = ({
  onCancel,
  onDone,
  onMoveToMyLocation,
  isMobileEnv,
}) => {
  const hint = (
    <div className="tw:flex tw:items-center tw:gap-2">
      <MoveIcon className="tw:size-4 tw:shrink-0 tw:text-muted-foreground" />
      <span className="tw:text-xs tw:font-medium tw:leading-4 tw:text-foreground">
        {Localization.translator.dragTheMapToChangeLocationPinPosition}
      </span>
    </div>
  )
  const myLocation = isMobileEnv && onMoveToMyLocation && (
    <Button variant="primary-ghost" size="lg" onClick={onMoveToMyLocation}>
      <LocateFixedIcon data-icon="inline-start" />
      {Localization.translator.moveToMyLocation}
    </Button>
  )
  const cancel = (
    <Button
      variant="outline"
      size="lg"
      onClick={onCancel}
      className={isMobileEnv ? 'tw:flex-1' : undefined}
    >
      {Localization.translator.cancel}
      {!isMobileEnv && <Kbd data-icon="inline-end">Esc</Kbd>}
    </Button>
  )
  const done = (
    <Button
      variant="default"
      size="lg"
      onClick={onDone}
      className={isMobileEnv ? 'tw:flex-1' : undefined}
    >
      <CheckIcon data-icon="inline-start" />
      {Localization.translator.done}
      {!isMobileEnv && (
        <Kbd
          data-icon="inline-end"
          className="tw:bg-background/20 tw:text-background"
        >
          ↵
        </Kbd>
      )}
    </Button>
  )
  if (isMobileEnv) {
    return (
      <div className="tw:flex tw:w-full tw:flex-col tw:items-center tw:gap-2">
        {hint}
        <div className="tw:flex tw:w-full tw:flex-wrap tw:items-center tw:justify-center tw:gap-2">
          {myLocation}
          {cancel}
          {done}
        </div>
      </div>
    )
  }
  return (
    <div className="tw:flex tw:flex-wrap tw:items-center tw:justify-center tw:gap-2">
      {hint}
      {cancel}
      {done}
    </div>
  )
}

export default MovePinControls
